import { memo, useMemo, useRef } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useReactToPrint } from "react-to-print";

export const TabelaPremioOperador = memo(function TabelaPremioOperador({
  data = [],
  turma = null,
  colProp = "p-col-12",
}) {
  const tableRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
  });

  const dadosFiltrados = useMemo(() => {
    return data.filter((item) => {
      if (turma && item.turma !== turma) return false;

      return true;
    });
  }, [data, turma]);

  const metragemBody = (rowData) => {
    return Intl.NumberFormat("pt-BR", {
      maximumFractionDigits: 2,
    }).format(rowData.metragem);
  };

  const premioBody = (rowData) => {
    return (
      Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
      }).format(rowData.premio) + "%"
    );
  };

  return (
    <div className={colProp}>
      <div ref={tableRef}>
        <div className="p-d-flex p-jc-between p-ai-center p-mb-2 no-print">
          <h3>Turma {turma}</h3>

          <Button
            icon="pi pi-print"
            onClick={handlePrint}
            className="print-hide"
          />
        </div>

        <DataTable
          value={dadosFiltrados}
          responsiveLayout="scroll"
          stripedRows
          showGridlines
        >
          <Column
            field="nome"
            header="Colaborador"
            sortable
            style={{ width: "50%" }}
          />

          <Column
            field="metragem"
            header="Metragem"
            sortable
            body={metragemBody}
            style={{ width: "25%" }}
          />

          <Column
            field="premio"
            header="Prêmio de Qualidade"
            sortable
            body={premioBody}
            style={{ width: "25%" }}
          />
        </DataTable>
      </div>
    </div>
  );
});
